module.exports = __webpack_public_path__ + "img/mPos-Logo.2cd1ccd9.svg";